import HeroImg from '../assets/hero.png' ;
import { AiOutlineLinkedin, AiOutlineGithub, AiOutlineInstagram, AiOutlineFacebook } from 'react-icons/ai';

export default function Hero () {
    const config = {
        subtitle: "I'm a Full Stack Developer",
        social : {
            linkedin : 'https://www.linkedin.com/in/sudharson-v/',
            github : 'https://github.com/VSudharson',
            insta : 'https://www.instagram.com/sudharson__2706/',
            facebook : 'https://www.facebook.com/Sudharson2706/'
        }
    }
    return <section className='flex flex-col md:flex-row px-5 py-32 bg-primary justify-center'>
        <div className='md:w-1/2 flex flex-col'>
            <h1 className=' text-white text-6xl font-hero-font'>Hi, <br/>I'm <span className='text-black'>V</span> Sudharson
                <p className='text-2xl'>{config.subtitle}</p>
            </h1>
            <div className='flex py-10'>
                <a target='_blank' href={config.social.linkedin} className='pr-5 hover:text-white'><AiOutlineLinkedin size={40}/></a>
                <a target='_blank' href={config.social.github} className='pr-5 hover:text-white'><AiOutlineGithub size={40}/></a>
                <a target='_blank' href={config.social.insta} className='pr-5 hover:text-white'><AiOutlineInstagram size={40}/></a>
                <a target='_blank' href={config.social.facebook} className='hover:text-white'><AiOutlineFacebook size={40}/></a>
            </div>
        </div>
        <img className='md:w-1/3' src={HeroImg} />

    </section>
}